import {makeStyles, Theme} from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    '& > .MuiDialog-container > .MuiPaper-root': {
      [theme.breakpoints.up('xs')]: {
        minWidth: 300,
      },
      [theme.breakpoints.up('sm')]: {
        minWidth: 500,
      },
      [theme.breakpoints.up('md')]: {
        minWidth: 650,
        minHeight: 350,
      },
    },
    '& .MuiDialog-paperScrollPaper': {},
  },
  headerDialog: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '20px',
  },

  contentWrap: {
    padding: '20px 45px',
  },

  headerMax: {
    border: '1px solid rgba(224, 224, 224, 1)',
    padding: 8,
  },

  closeIcon: {
    width: 20,
    height: 20,
    color: '#c5c5c5',
  },
  closeButton: {
    backgroundColor: '#f4f4f4',
    width: 20,
    height: 20,
  },
  closeButtonWrap: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '15px',
    marginTop: '10px',
  },
  input: {
    width: 100,
    border: '1px solid #e0e0e0',
    minHeight: 36,
    paddingLeft: 10,
    paddingRight: 10,
    height: 36,
    outline: 'none',
    borderRadius: 4,
    margin: '10px 0',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
  },
  infoCard: {
    background: '#f0fdf4',
    border: '1px solid #bbf7d0',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '20px',
    marginTop: '20px',
  },
  dangerCard: {
    background: '#fee2e2',
    border: '1px solid #fca5a1',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '20px',
    marginTop: '20px',
  },
  searchSelect: {
    width: '100%',
    height: 40,
  },
  infoItem: {
    display: 'flex',
    gap: 5,
    alignItems: 'center',
    marginBottom: '8px',
    fontSize: '14px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  searchSelectV1: {
    width: '120px',
    height: 35,
    marginRight: '15px',
  },
  infoLabel: {
    color: '#374151',
    fontWeight: 500,
  },

  infoValue: {
    color: '#10b981',
    fontWeight: 600,
  },
  dangerValue: {
    color: '#dc2626',
    fontWeight: 600,
  },
  listBtn: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
    gap: 30,
  },

  infoTitle: {
    width: '120px',
  },
}))

export default useStyles
